<template>
  <v-app>
    <v-container fluid>
      <v-dialog v-model="successPaymentMidtrans" max-width="350">
        <v-card>
          <v-card-title class="headline justify-center">
            <v-img
              max-height="44"
              max-width="42"
              src="@/assets/check-green.png"
            ></v-img>
          </v-card-title>
          <v-card-text class="text-center"
            >{{ objMsg.msg }}</v-card-text
          >
          <v-card-text class="text-center">
            <v-spacer></v-spacer>
            <v-btn
              style="border-color: yellow"
              outlined
              class="text-capitalize ml-2"
              small
              text
              color="black"
              @click="successPaymentMidtrans = false"
            >
              {{ objMsg.btn }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="warnPesananReward" max-width="350">
        <v-card>
          <v-card-title class="headline justify-center">
            <v-img
              max-height="44"
              max-width="42"
              src="@/assets/alert.jpg"
            ></v-img>
          </v-card-title>
          <v-card-text class="text-center"
            >{{ objMsg.msg }}</v-card-text
          >
          <v-card-text class="text-center">
            <v-spacer></v-spacer>
            <v-btn
              style="border-color: yellow"
              outlined
              class="text-capitalize ml-2"
              small
              text
              color="black"
              @click="warnPesananReward = false"
            >
              Batal
            </v-btn>
            <v-btn
              style="border-color: yellow"
              outlined
              class="text-capitalize ml-2"
              small
              text
              color="red"
              @click="cancelOrderRewardFunc"
            >
              Tolak
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="warnPesananRewardPesan" max-width="350">
        <v-card>
          <v-card-title class="headline justify-center">
            <v-img
              max-height="44"
              max-width="42"
              src="@/assets/alert.jpg"
            ></v-img>
          </v-card-title>
          <v-card-text class="text-center"
            >{{ objMsg.msg }}</v-card-text
          >
          <v-card-text class="text-center">
            <v-spacer></v-spacer>
            <v-btn
              style="border-color: yellow"
              outlined
              class="text-capitalize ml-2"
              small
              text
              color="black"
              @click="warnPesananRewardPesan = false"
            >
              Batal
            </v-btn>
            <v-btn
              style="border-color: yellow"
              outlined
              class="text-capitalize ml-2"
              small
              text
              color="red"
              @click="pesanOrderRewardFunc"
            >
              Pesan
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="alertPayment"
        persistent
        max-width="450"
        height="550px"
        width="100%"
      >
        <v-card>
          <v-card-text class="text-center">
            <h3>
              Total dibayar: Rp {{ this.humanFormat(this.priceInput) }} , dari
              {{ this.totalPriceStr }}
            </h3>
          </v-card-text>
          <v-card-text class="text-center">
            <v-spacer></v-spacer>
            <v-btn
              class="text-capitalize"
              small
              color="primary"
              elevation="0"
              @click="cancelPayment()"
            >
              Batal
            </v-btn>
            <v-btn
              style="border-color: yellow"
              outlined
              class="text-capitalize ml-2"
              small
              text
              color="black"
              @click="toPaymentScreen()"
            >
              Bayar Sekarang
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>


      <v-row no-gutters>
        <v-col cols="12" class="container-content">
          <v-tabs
            grow
            @change="onParentTabChange"
            v-model="activeParentsTab"
            style="border-radius: 18px"
            class="pa-4"
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#tab-OS_ALL_TRANS">
              Semua Transaksi </v-tab
            >
            <v-tab href="#tab-OS_REWARD_TRANS">
              Persetujuan Reward Anda</v-tab
            >

            <v-tab-item value="tab-OS_ALL_TRANS" class="mt-3">
              <v-tabs
                grow
                @change="onTabChange"
                v-model="activeTransTab"
                style="border-radius: 18px"
                class="pa-4"
              >
                <v-tabs-slider></v-tabs-slider>
                <v-tab href="#tab-OS_NEW">
                  Pesanan Anda ( {{ this.countMenungguKiriman }} )</v-tab
                >
                <v-tab href="#tab-OS_PACKING">
                  Di Kemas ( {{ this.countDikemas }} )</v-tab
                >
                <v-tab href="#tab-OS_UNPAID">
                  Belum Dibayar ( {{ this.countBelumDibayar }} )</v-tab
                >
                <v-tab href="#tab-OS_PAID"> Lunas ( {{ this.countLunas }} )</v-tab>
                <v-tab href="#tab-OS_CANCELED">
                  Dibatalkan ( {{ this.countDibatalkan }} )</v-tab
                >

                <v-tab-item value="tab-OS_NEW" class="mt-3">
                  <div v-if="!this.transactionList.new.length && flagTrx == true">
                    <div class="emptyTrx">
                      <p class="font-weight-medium text-lg-h5 text-center">
                        Belum ada Pesanan, Silahkan pesan 
                      </p>
                    </div>
                  </div>
                  <div v-else>
                    <v-text-field
                      label="Cari Nomor Order"
                      prepend-inner-icon="mdi-magnify"
                      outlined
                      hide-details="auto"
                      v-model="keyword.OS_NEW"
                      @keypress="handleNoEnter"
                      @input="handleFindOrderByStatus('OS_NEW')"
                      autocomplete="off"
                    ></v-text-field>
                    <v-row class="card-order" no-gutters>
                      <v-col
                        xl="4"
                        lg="4"
                        md="4"
                        sm="6"
                        cols="12"
                        v-for="item in this.transactionList.new"
                        :key="item.internalId"
                      >
                        <TransactionCard :item="item" mode="nonreward"></TransactionCard>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>

                <v-tab-item value="tab-OS_PACKING" class="mt-5">
                  <div v-if="!this.transactionList.packing.length && flagTrx == true">
                    <div class="emptyTrx">
                      <p class="font-weight-medium text-lg-h5 text-center">
                        Belum ada barang yang di kemas.
                      </p>
                    </div>
                  </div>
                  <div v-else>
                    <v-text-field
                      label="Cari Nomor Order"
                      prepend-inner-icon="mdi-magnify"
                      outlined
                      hide-details="auto"
                      v-model="keyword.OS_PACKING"
                      @keypress="handleNoEnter"
                      @input="handleFindOrderByStatus('OS_PACKING')"
                      autocomplete="off"
                    ></v-text-field>
                    <v-row class="card-order" no-gutters>
                      <v-col
                        xl="4"
                        lg="4"
                        md="4"
                        sm="6"
                        cols="12"
                        v-for="item in this.transactionList.packing"
                        :key="item.internalId"
                      >
                        <TransactionCard :item="item" mode="nonreward"></TransactionCard>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>

                <v-tab-item value="tab-OS_UNPAID" class="mt-5">
                  <div v-if="!this.transactionList.unpaid.length && flagTrx == true">
                    <div class="emptyTrx">
                      <p class="font-weight-medium text-lg-h5 text-center">
                        Belum ada transaksi yang harus dibayar
                      </p>
                    </div>
                  </div>
                  <div v-else>
                    <v-text-field
                      label="Cari Nomor Order"
                      prepend-inner-icon="mdi-magnify"
                      outlined
                      hide-details="auto"
                      v-model="keyword.OS_UNPAID"
                      @keypress="handleNoEnter"
                      @input="handleFindOrderByStatus('OS_UNPAID')"
                      autocomplete="off"
                    ></v-text-field>
                    <v-row>
                      <v-col cols="12">
                        <div class="">
                          <p class="font-weight-bold">Harga Total: <span>{{ this.totalPriceStr }}</span></p>
                          <v-btn
                            class="text-capitalize mr-3"
                            color="primary"
                            @click="toPaymentScreen()"
                          >
                            Bayar</v-btn
                          >
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-row class="card-order" no-gutters>
                          <v-col
                        xl="4"
                        lg="4"
                        md="4"
                        sm="6"
                        cols="12"
                        v-for="item in this.transactionList.unpaid"
                        :key="item.internalId"
                      >
                        <TransactionCard :item="item" mode="nonreward"></TransactionCard>
                      </v-col>
                        </v-row>
                      </v-col>
                      <!-- <v-col cols="5">
                        <v-row class="card-order">
                          <v-col cols="12">
                            <v-expansion-panels accordion>
                              <v-expansion-panel>
                                <v-expansion-panel-header
                                  ><v-col cols="7" class="font-weight-bold"
                                    >Total Pembayaran</v-col
                                  >
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <v-col cols="12">
                                    <v-row>
                                      <v-col cols="7" class="font-weight-bold"
                                        >Harga Total</v-col
                                      >
                                      <v-col cols="5" class="text-right">
                                        {{ this.totalPriceStr }}</v-col
                                      >
                                    </v-row>
                                  </v-col>

                                  <v-col cols="12">
                                    <v-btn
                                      class="text-capitalize mr-3"
                                      width="100%"
                                      large
                                      color="primary"
                                      @click="toPaymentScreen()"
                                    >
                                      Bayar</v-btn
                                    >
                                  </v-col>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-col>
                        </v-row>
                      </v-col> -->
                    </v-row>
                  </div>
                </v-tab-item>

                <v-tab-item value="tab-OS_PAID" class="mt-5">
                  <div v-if="!this.transactionList.paid.length">
                    <div class="emptyTrx">
                      <p class="font-weight-medium text-lg-h5 text-center">
                        Belum ada Transaksi
                      </p>
                    </div>
                  </div>
                  <div v-else>
                    <v-text-field
                      label="Cari Nomor Order"
                      prepend-inner-icon="mdi-magnify"
                      outlined
                      hide-details="auto"
                      v-model="keyword.OS_PAID"
                      @keypress="handleNoEnter"
                      @input="handleFindOrderByStatus('OS_PAID')"
                      autocomplete="off"
                    ></v-text-field>
                    <v-row class="card-order" no-gutters>
                      <v-col
                        xl="4"
                        lg="4"
                        md="4"
                        sm="6"
                        cols="12"
                        v-for="item in this.transactionList.paid"
                        :key="item.internalId"
                      >
                        <TransactionCard :item="item" mode="nonreward"></TransactionCard>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>

                <v-tab-item value="tab-OS_CANCELED" class="mt-5">
                  <div v-if="!this.transactionList.canceled.length && flagTrx == true">
                    <div class="emptyTrx">
                      <p class="font-weight-medium text-lg-h5 text-center">
                        Belum ada Transaksi
                      </p>
                    </div>
                  </div>
                  <div v-else>
                    <v-text-field
                      label="Cari Nomor Order"
                      prepend-inner-icon="mdi-magnify"
                      outlined
                      hide-details="auto"
                      v-model="keyword.OS_CANCELED"
                      @keypress="handleNoEnter"
                      @input="handleFindOrderByStatus('OS_CANCELED')"
                      autocomplete="off"
                    ></v-text-field>
                    <v-row class="card-order" no-gutters>
                      <v-col
                        xl="4"
                        lg="4"
                        md="4"
                        sm="6"
                        cols="12"
                        v-for="item in this.transactionList.canceled"
                        :key="item.internalId"
                      >
                        <TransactionCard :item="item" mode="nonreward"></TransactionCard>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>
              </v-tabs>
            </v-tab-item>

            <v-tab-item value="tab-OS_REWARD_TRANS" class="mt-3">
              <v-tabs
                grow
                @change="onTabChangeReward"
                v-model="activeRewardTab"
                style="border-radius: 18px"
                class="pa-4"
              >
                <v-tabs-slider></v-tabs-slider>
                <v-tab href="#tab-OS_NEW_REWARD">
                 Cek Stok  ( {{ this.countRewardNew }} )</v-tab
                >
                <v-tab href="#tab-OS_CLAIM_REWARD">
                  Stok Tersedia ( {{ this.countRewardClaim }} )</v-tab
                >
                <v-tab href="#tab-OS_CANCELED_REWARD">
                  Canceled ( {{ this.countRewardCanceled }} )</v-tab
                >

                <v-tab-item value="tab-OS_NEW_REWARD" class="mt-5">
                  <div v-if="!this.rewardPointList.new.length && flagTrx == true">
                    <div class="emptyTrx">
                      <p class="font-weight-medium text-lg-h5 text-center">
                        Belum ada Transaksi
                      </p>
                    </div>
                  </div>
                  <div v-else>
                    <v-text-field
                      label="Cari Nomor Order"
                      prepend-inner-icon="mdi-magnify"
                      outlined
                      hide-details="auto"
                      v-model="keywordReward.NEW"
                      @keypress="handleNoEnter"
                      @input="handleFindOrderRewardByStatus('NEW')"
                      autocomplete="off"
                    ></v-text-field>
                    <v-row class="card-order" no-gutters>
                      <v-col
                        xl="4"
                        lg="4"
                        md="4"
                        sm="6"
                        cols="12"
                        v-for="item in this.rewardPointList.new"
                        :key="item.internalId"
                      >
                        <TransactionCard :item="item" mode="reward" tab="tabReward" ></TransactionCard>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>

                <v-tab-item value="tab-OS_CLAIM_REWARD" class="mt-5">
                  <div v-if="!this.rewardPointList.claim.length && flagTrx == true">
                    <div class="emptyTrx">
                      <p class="font-weight-medium text-lg-h5 text-center">
                        Belum ada Transaksi
                      </p>
                    </div>
                  </div>
                  <div v-else>
                    <v-text-field
                      label="Cari Nomor Order"
                      prepend-inner-icon="mdi-magnify"
                      outlined
                      hide-details="auto"
                      v-model="keywordReward.CLAIM"
                      @keypress="handleNoEnter"
                      @input="handleFindOrderRewardByStatus('CLAIM')"
                      autocomplete="off"
                    ></v-text-field>
                    <v-row class="card-order" no-gutters>
                      <v-col
                        xl="4"
                        lg="4"
                        md="4"
                        sm="6"
                        cols="12"
                        v-for="item in this.rewardPointList.claim"
                        :key="item.internalId"
                      >
                        <TransactionCard :item="item" mode="reward" tab="tabReward"
                        @tolak-item="validateCancelOrderReward"
                         @pesan-item="validatePesanOrderReward"></TransactionCard>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>

                <v-tab-item value="tab-OS_CANCELED_REWARD" class="mt-5">
                  <div v-if="!this.rewardPointList.canceled.length && flagTrx == true">
                    <div class="emptyTrx">
                      <p class="font-weight-medium text-lg-h5 text-center">
                        Belum ada Transaksi
                      </p>
                    </div>
                  </div>
                  <div v-else>
                    <v-text-field
                      label="Cari Nomor Order"
                      prepend-inner-icon="mdi-magnify"
                      outlined
                      hide-details="auto"
                      v-model="keywordReward.CANCELED"
                      @keypress="handleNoEnter"
                      @input="handleFindOrderRewardByStatus('CANCELED')"
                      autocomplete="off"
                    ></v-text-field>
                    <v-row class="card-order" no-gutters>
                      <v-col
                        xl="4"
                        lg="4"
                        md="4"
                        sm="6"
                        cols="12"
                        v-for="item in this.rewardPointList.canceled"
                        :key="item.internalId"
                      >
                        <TransactionCard :item="item" mode="reward" tab="tabReward"></TransactionCard>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>
              </v-tabs>
            </v-tab-item>

          </v-tabs>

        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn color="primary" v-if="this.showLoadMore" @click="nextPage()">
          Load More
        </v-btn>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TransactionCard from "../../components/TransactionCard/TransactionCard.vue";

export default {
  name: "Transactions",
  components: {
    TransactionCard
  },
  data() {
    return {
      internalId: '',
      countRewardNew: 0,
      countRewardClaim: 0,
      countRewardCanceled: 0,
      searchOrderNo: "",
      searchOrderNoReward: "",
      alertPayment: false,
      successPaymentMidtrans: false,
      countMenungguKiriman: 0,
      countBelumDibayar: 0,
      countLunas: 0,
      countDibatalkan: 0,
      countDikemas: 0,
      currentDate: this.$moment().format("DD-MM-YYYY"),
      keyword: {
        OS_NEW: "",
        OS_PAID: "",
        OS_CANCELED: "",
        OS_PACKING: "",
      },
      keywordReward: {
        NEW: "",
        CLAIM: "",
        CANCELED: "",
      },
      activeTransTab: null,
      activeParentsTab: null,
      activeRewardTab: null,
      transactionList: {
        new: [],
        unpaid: [],
        paid: [],
        canceled: [],
        packing: [],
      },
      rewardPointList: {
        new: [],
        claim: [],
        canceled: [],
      },
      pageLoad: 2,
      pageLoadReward: 2,
      showLoadMore: false,
      totalPrice: 0,
      totalPriceStr: "",
      statusChangeTab: "",
      statusChangeTabReward: "",
      priceInput: 0,
      priceInputTobePaid: 0,
      flagTrx: true,
      objMsg: {
        msg: '',
        btn: ''
      },
      warnPesananReward: false,
      warnPesananRewardPesan: false,
      item: {},
      currentTab: '',
    };
  },
  props: [
    'tab'
  ],
  methods: {
    ...mapActions([
      "changeTitleApp",
      "getTransactions",
      "getToken",
      "getStatusPayment",
      "checkoutOrder",
      "viewRewardPoint",
      "updateStatus",
      "cancelOrderReward"
      ,"addOrderReward",
      "getOrderReward"
    ]),
    toPaymentScreen() {
      this.$store.state.paymentTotal = this.totalPriceStr;
      this.$router.push({ name: "payment" });
    },
    toTransaction() {
      this.loadTransactions({
        pageNumber: 1,
        pageSize: 10,
        searchVal: "",
        status: "OS_UNPAID",
      });
      this.successPaymentMidtrans = false;
    },
    cancelPayment() {
      this.alertPayment = false;
    },
    validatePayment() {
      this.alertPayment = true;
    },

    invokeGetStatus(arg) {
      this.getStatus(arg).then((resp) => {
        console.log(resp);
      });
    },

    validatePesanOrderReward(item){
      this.item = item;

      this.objMsg.msg = 'Apakah Kamu yakin ingin pesan ?'
      this.warnPesananRewardPesan = true;
      console.log('masuk pak eko')
    },

    pesanOrderRewardFunc(){

        // HIT API ADD ORDER
        this.addOrderReward({
          internalId: this.item.internalId,
          poin: this.item.points
        })
        .then(() => {
          this.objMsg.msg = 'Pesanan Anda berhasil di proses';
          this.objMsg.btn = 'Ok';
          this.warnPesananRewardPesan = false;
          this.successPaymentMidtrans = true;

          this.loadRewardPointList(
            {
              pageNumber: 1,
              pageSize: 10,
              rewardNo: "",
              status: "CLAIM"
            }
          )
        })

    },

    validateCancelOrderReward(item){
      this.item = item;

      this.objMsg.msg = 'Apakah Kamu yakin ingin batalkan pesan ?'
      this.warnPesananReward = true;
    },

    cancelOrderRewardFunc(){
      this.cancelOrderReward({
        internalId: this.item.internalId
      })
      .then(() => {
        this.objMsg.msg = 'Pesanan Anda berhasil di tolak'
        this.objMsg.btn = 'Ok'
        this.warnPesananReward = false;
        this.successPaymentMidtrans = true;

        this.loadRewardPointList(
          {
            pageNumber: 1,
            pageSize: 10,
            rewardNo: "",
            status: "CLAIM"
          }
        )
      })
    },

    setAttributes(el, options) {
      Object.keys(options).forEach(function(attr) {
        el.setAttribute(attr, options[attr]);
      });
    },

    nextPage() {
      console.log("tombol di klik");
      if (this.currentTab == 'tab-OS_ALL_TRANS') {
        this.getTransactions({
          pageNumber: this.pageLoad,
          pageSize: 10,
          searchVal: this.searchOrderNo,
          status: this.statusChangeTab,
        }).then((response) => {
          console.log("testt");
          if (response.data.status == 1) {
            switch (this.statusChangeTab) {
              case "OS_NEW":
                this.transactionList.new.push.apply(
                  this.transactionList.new,
                  response.data.data.listData
                );

                if (this.searchOrderNo != "") {
                  this.showLoadMore =
                    this.transactionList.new.length < response.data.data.totalData
                      ? true
                      : false;
                } else {
                  this.showLoadMore =
                    this.transactionList.new.length >= this.countMenungguKiriman
                      ? false
                      : true;
                }

                console.log("length: " + this.transactionList.new.length);

                break;
              case "OS_UNPAID":
                this.transactionList.unpaid.push.apply(
                  this.transactionList.unpaid,
                  response.data.data.listData
                );

                if (this.searchOrderNo != "") {
                  this.showLoadMore =
                    this.transactionList.unpaid.length <
                    response.data.data.totalData
                      ? true
                      : false;
                } else {
                  this.showLoadMore =
                    this.transactionList.unpaid.length >= this.countBelumDibayar
                      ? false
                      : true;
                }
                break;
              case "OS_PAID":
                this.transactionList.paid.push.apply(
                  this.transactionList.paid,
                  response.data.data.listData
                );

                if (this.searchOrderNo != "") {
                  this.showLoadMore =
                    this.transactionList.paid.length <
                    response.data.data.totalData
                      ? true
                      : false;
                } else {
                  this.showLoadMore =
                    this.transactionList.paid.length >= this.countLunas
                      ? false
                      : true;
                }

                console.log("length: " + this.transactionList.paid.length);
                break;
              case "OS_CANCELED":
                this.transactionList.canceled.push.apply(
                  this.transactionList.canceled,
                  response.data.data.listData
                );

                if (this.searchOrderNo != "") {
                  this.showLoadMore =
                    this.transactionList.canceled.length <
                    response.data.data.totalData
                      ? true
                      : false;
                } else {
                  this.showLoadMore =
                    this.transactionList.canceled.length >= this.countDibatalkan
                      ? false
                      : true;
                }
                break;
            }
          }
        });

        this.pageLoad += 1;
      }else{
        this.viewRewardPoint({
          pageNumber: this.pageLoadReward,
          pageSize: 10,
          searchVal: this.searchOrderNo,
          status: this.statusChangeTabReward,
        }).then((response) => {
          console.log("testt");
          if (response.data.status == 1) {
            switch (this.statusChangeTabReward) {
              case "NEW":
                this.rewardPointList.new.push.apply(
                  this.rewardPointList.new,
                  response.data.data.listData
                );

                if (this.searchOrderNo != "") {
                  this.showLoadMore =
                    this.rewardPointList.new.length < response.data.data.totalData
                      ? true
                      : false;
                } else {
                  this.showLoadMore =
                    this.rewardPointList.new.length >= this.countRewardNew
                      ? false
                      : true;
                }

                console.log("length: " + this.rewardPointList.new.length);

                break;
              case "CLAIM":
                this.rewardPointList.claim.push.apply(
                  this.rewardPointList.claim,
                  response.data.data.listData
                );

                if (this.searchOrderNo != "") {
                  this.showLoadMore =
                    this.rewardPointList.claim.length <
                    response.data.data.totalData
                      ? true
                      : false;
                } else {
                  this.showLoadMore =
                    this.rewardPointList.claim.length >= this.countRewardClaim
                      ? false
                      : true;
                }
                break;
              case "CANCELED":
                this.rewardPointList.canceled.push.apply(
                  this.rewardPointList.canceled,
                  response.data.data.listData
                );

                if (this.searchOrderNo != "") {
                  this.showLoadMore =
                    this.rewardPointList.canceled.length <
                    response.data.data.totalData
                      ? true
                      : false;
                } else {
                  this.showLoadMore =
                    this.rewardPointList.canceled.length >= this.countRewardCanceled
                      ? false
                      : true;
                }

                console.log("length: " + this.rewardPointList.canceled.length);
                break;
            }
          }
        });

        this.pageLoadReward += 1;
      }
    },
    loadTransactions(args) {
      this.getTransactions(args)
        .then((response) => {
          //SET COUNT DATA STATUS
          this.countDikemas = response.data.countDataStatusPacking;
          this.countMenungguKiriman = response.data.countDataStatusNew;
          this.countLunas = response.data.countDataStatusPaid;
          this.countBelumDibayar = response.data.countDataStatusUnpaid;
          this.countDibatalkan = response.data.countDataStatusCanceled;

          switch (args.status) {
            case "OS_NEW":
              this.transactionList.new = response.data.data.listData;

              if (this.searchOrderNo != "") {
                this.showLoadMore =
                  this.transactionList.new.length < response.data.data.totalData
                    ? true
                    : false;
              } else {
                this.showLoadMore =
                  this.transactionList.new.length < this.countMenungguKiriman
                    ? true
                    : false;
              }

              this.statusChangeTab = args.status;
              this.pageLoad = 2;
              break;
            case "OS_PACKING":
              this.transactionList.packing = response.data.data.listData;

              if (this.searchOrderNo != "") {
                this.showLoadMore =
                  this.transactionList.packing.length <
                  response.data.data.totalData
                    ? true
                    : false;
              } else {
                this.showLoadMore =
                  this.transactionList.packing.length < this.countDikemas
                    ? true
                    : false;
              }

              this.statusChangeTab = args.status;
              this.pageLoad = 2;
              break;
            case "OS_UNPAID":
              this.transactionList.unpaid = response.data.data.listData;

              if (this.searchOrderNo != "") {
                this.showLoadMore =
                  this.transactionList.unpaid.length <
                  response.data.data.totalData
                    ? true
                    : false;
              } else {
                this.showLoadMore =
                  this.transactionList.unpaid.length < this.countBelumDibayar
                    ? true
                    : false;
              }

              this.statusChangeTab = args.status;
              this.pageLoad = 2;

              this.checkoutOrder().then((resp) => {
                console.log(resp);
                this.totalPrice = resp.data.totalPriceOrderDecimal;
                this.totalPriceStr = resp.data.totalPriceOrder;
              });
              break;
            case "OS_PAID":
              this.transactionList.paid = response.data.data.listData;

              if (this.searchOrderNo != "") {
                this.showLoadMore =
                  this.transactionList.paid.length <
                  response.data.data.totalData
                    ? true
                    : false;
              } else {
                this.showLoadMore =
                  this.transactionList.paid.length < this.countLunas
                    ? true
                    : false;
              }

              this.statusChangeTab = args.status;
              this.pageLoad = 2;
              break;
            case "OS_CANCELED":
              this.transactionList.canceled = response.data.data.listData;

              if (this.searchOrderNo != "") {
                this.showLoadMore =
                  this.transactionList.canceled.length <
                  response.data.data.totalData
                    ? true
                    : false;
              } else {
                this.showLoadMore =
                  this.transactionList.canceled.length < this.countDibatalkan
                    ? true
                    : false;
              }

              this.statusChangeTab = args.status;
              this.pageLoad = 2;
              break;
          }
          this.$helpers.handleSuccess(response);
        })
        .catch((error) => {
          this.$helpers.handleError(error);
        });
    },
    loadRewardPointList(args){
      this.viewRewardPoint(args)
      .then((response) => {
        console.log(response)
         //SET COUNT DATA STATUS
         this.countRewardClaim = response.data.countDataStatusClaim;
          this.countRewardNew = response.data.countDataStatusNew;
          this.countRewardCanceled = response.data.countDataStatusCanceled;

          switch (args.status) {
            case "NEW":
              this.rewardPointList.new = response.data.data.listData;
              if (this.searchOrderNoReward != "") {
                this.showLoadMore =
                this.rewardPointList.new.length && this.rewardPointList.new.length < response.data.data.totalData
                    ? true
                    : false;
              } else {
                this.showLoadMore =
                this.rewardPointList.new.length && this.rewardPointList.new.length < this.countRewardNew
                    ? true
                    : false;
              }

              this.statusChangeTabReward = args.status;
              this.pageLoadReward = 2;
              break;
            case "CLAIM":
              this.rewardPointList.claim = response.data.data.listData;

              if (this.searchOrderNoReward != "") {
                this.showLoadMore =
                this.rewardPointList.claim.length && this.rewardPointList.claim.length <
                  response.data.data.totalData
                    ? true
                    : false;
              } else {
                this.showLoadMore =
                this.rewardPointList.claim.length && this.rewardPointList.claim.length < this.countRewardClaim
                    ? true
                    : false;
              }

              this.statusChangeTabReward = args.status;
              this.pageLoadReward = 2;
              break;
            case "CANCELED":
              this.rewardPointList.canceled = response.data.data.listData;

              if (this.searchOrderNoReward != "") {
                this.showLoadMore =
                this.rewardPointList.canceled.length && this.rewardPointList.canceled.length <
                  response.data.data.totalData
                    ? true
                    : false;
              } else {
                this.showLoadMore =
                this.rewardPointList.canceled.length && this.rewardPointList.canceled.length < this.countRewardCanceled
                    ? true
                    : false;
              }

              this.statusChangeTabReward = args.status;
              this.pageLoadReward = 2;
              break;
          }
      });
    },
    onParentTabChange: function(
      clickedTab //udah dipanggil di layout
    ) {
      switch (clickedTab) {
        case "tab-OS_ALL_TRANS":
          this.currentTab = 'tab-OS_ALL_TRANS'
          this.activeTransTab = `tab-OS_NEW`;
          this.loadTransactions({
            pageNumber: 1,
            pageSize: 10,
            searchVal: "",
            status: "OS_NEW",
          });
          break;
        case "tab-OS_REWARD_TRANS":
          this.currentTab = 'tab-OS_REWARD_TRANS'
          this.activeRewardTab = `tab-OS_NEW_REWARD`;
          this.loadRewardPointList({
            pageNumber: 1,
            pageSize: 10,
            rewardNo: "",
            status: "NEW"
          });
          break;
      }
    },
    onTabChange: function(
      clickedTab //udah dipanggil di layout
    ) {
      switch (clickedTab) {
        case "tab-OS_NEW":
          this.loadTransactions({
            pageNumber: 1,
            pageSize: 10,
            searchVal: "",
            status: "OS_NEW",
          });
          break;
        case "tab-OS_PACKING":
          this.loadTransactions({
            pageNumber: 1,
            pageSize: 10,
            searchVal: "",
            status: "OS_PACKING",
          });
          break;
        case "tab-OS_PAID":
          this.loadTransactions({
            pageNumber: 1,
            pageSize: 10,
            searchVal: "",
            status: "OS_PAID",
          });
          break;
        case "tab-OS_CANCELED":
          this.loadTransactions({
            pageNumber: 1,
            pageSize: 10,
            searchVal: "",
            status: "OS_CANCELED",
          });
          break;
        case "tab-OS_UNPAID":
          this.loadTransactions({
            pageNumber: 1,
            pageSize: 10,
            searchVal: "",
            status: "OS_UNPAID",
          });
          break;
      }
    },
    onTabChangeReward: function(
      clickedTab //udah dipanggil di layout
    ) {
      switch (clickedTab) {
        case "tab-OS_NEW_REWARD":
          this.loadRewardPointList({
            pageNumber: 1,
            pageSize: 10,
            rewardNo: "",
            status: "NEW",
          });
          break;
        case "tab-OS_CLAIM_REWARD":
          this.loadRewardPointList({
            pageNumber: 1,
            pageSize: 10,
            rewardNo: "",
            status: "CLAIM",
          });
          break;
        case "tab-OS_CANCELED_REWARD":
          this.loadRewardPointList({
            pageNumber: 1,
            pageSize: 10,
            rewardNo: "",
            status: "CANCELED",
          });
          break;
      }
    },
    handleNoEnter: function(e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode === 13) {
        e.preventDefault();
        return false;
      }
    },
    handleFindOrderByStatus: function(orderStatus) {
      if (
        (this.keyword[orderStatus] && this.keyword[orderStatus].length > 2) ||
        this.keyword[orderStatus] == ""
      ) {
        this.searchOrderNo = this.keyword[orderStatus].toUpperCase();

        this.loadTransactions({
          pageNumber: 1,
          pageSize: 10,
          searchVal: this.searchOrderNo,
          status: orderStatus,
        });

        this.flagTrx = false;
      }
    },
    handleFindOrderRewardByStatus: function(orderStatus) {
      console.log(this.keywordReward[orderStatus])
      if (
        (this.keywordReward[orderStatus] && this.keywordReward[orderStatus].length > 2) ||
        this.keywordReward[orderStatus] == ""
      ) {
        this.searchOrderNoReward = this.keywordReward[orderStatus].toUpperCase();

        this.loadRewardPointList({
          pageNumber: 1,
          pageSize: 10,
          rewardNo: this.searchOrderNoReward,
          status: orderStatus,
        });

        this.flagTrx = false;
      }
    },
  },
  created() {
    this.changeTitleApp("Transaksi");
  },
  mounted() {
    console.log(this.tab)
    this.currentTab = this.tab;
    this.activeParentsTab = this.tab;
  },
  computed: {
    ...mapState(["transactions", "tokenWeb", "userTypeWeb", "paymentTotal"]),

  },
};
</script>

<style src="./Transactions.scss" lang="scss" />
